import axios from "axios";
import { appConfigs } from "../../../../../_yp_db/_helpers";

// CREATE =>  POST: add a new event to the server
export function createEvent(event) {
  return axios.post(appConfigs.api_url + 'events/create', { event });
}

// READ
export function getAllEvents() {
  return axios.post(appConfigs.api_url + 'events');
}

export function getEventById(eventId) {
  return axios.post(`${appConfigs.api_url}events/get`, { id: eventId })
}

//getEventAttendanceById
export function getEventAttendanceById(eventId) {
  return axios.post(`${appConfigs.api_url}events/get-attendance`, { eventId })
}

//addEventAttendance
export function addEventAttendance(event) {
  return axios.post(`${appConfigs.api_url}events/add-attendance`, { event });
}

//updateEventAttendance
export function updateEventAttendance(event) {
  return axios.post(`${appConfigs.api_url}events/update-attendance`, { event });
}

//removeEventAttendance
export function removeEventAttendance(event) {
  return axios.post(`${appConfigs.api_url}events/remove-attendance`, { event });
}

//bulkAddEventAttendance
export function bulkAddEventAttendance(eventAttendance) {
  return axios.post(`${appConfigs.api_url}events/bulk-add-attendance`, { eventAttendance });
}


//fetchProfessionals
export function fetchProfessionals(search) {
  return axios.post(`${appConfigs.api_url}events/fetch-professionals`, { search });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findEvents(queryParams) {
  return axios.post(`${appConfigs.api_url}events`, { queryParams });
}

// UPDATE => POST: update the event on the server
export function updateEvent(event) {
  return axios.post(`${appConfigs.api_url}events/update`, { event });
}

// UPDATE Status
export function updateStatusForEvents(ids, status) {
  return axios.post(`${appConfigs.api_url}/updateStatusForEvents`, {
    ids,
    status
  });
}

//getAttendanceReport
export function getAttendanceReport(eventId) {
  return axios.post(`${appConfigs.api_url}events/get-attendance-report`, { eventId })
}

// DELETE => delete the event from the server
export function deleteEvent(eventId) {
  return axios.post(`${appConfigs.api_url}events/delete`, { id: eventId });
}

// DELETE Events by ids
export function deleteEvents(ids) {
  return axios.post(`${appConfigs.api_url}events/delete-events`, { event_ids: ids });
}
